export default __webpack_public_path__ + "static/media/es-ce.cde46b1e.svg";